import { atom } from "jotai";

const cartInitializerAtom = atom<boolean>(false)

export default cartInitializerAtom